export const messages = {
  en: {
    roomRenovationManage: {
      queryCondition: "Query Condition",
      hide: "Hide",
      more: "More",
      roomNumberPlaceholder: "Please enter room number (e.g. 1-1-101)",
      contactPersonPlaceholder: "Please enter contact person",
      phonePlaceholder: "Please enter phone number",
      search: "Search",
      reset: "Reset",
      statusPlaceholder: "Please select status",
      postponePlaceholder: "Please select if postponed",
      renovationTimePlaceholder: "Please select renovation time",
      startTimePlaceholder: "Please select start time",
      endTimePlaceholder: "Please select end time",
      renovationInfo: "Renovation Information",
      add: "Add",
      room: "Room",
      contactPerson: "Contact Person",
      phone: "Phone",
      renovationTime: "Renovation Time",
      applyTime: "Apply Time",
      renovationCompany: "Renovation Company",
      renovationManager: "Renovation Manager",
      managerPhone: "Manager Phone",
      status: "Status",
      isPostponed: "Is Postponed",
      postponeTime: "Postpone Time",
      isViolation: "Is Violation",
      violationDesc: "Violation Description",
      remark: "Remark",
      operation: "Operation",
      fee: "Fee",
      review: "Review",
      completeRenovation: "Complete Renovation",
      renovationAcceptance: "Renovation Acceptance",
      acceptanceDetail: "Acceptance Detail",
      modify: "Modify",
      delete: "Delete",
      trackRecord: "Track Record",
      yes: "Yes",
      no: "No",
      confirmDelete: "Confirm Delete",
      confirmDeleteMsg: "Are you sure to delete this renovation record?",
      cancelDelete: "Cancel",
      confirmComplete: "Confirm Complete",
      confirmCompleteMsg: "Are you sure to mark this renovation as completed?",
      cancelComplete: "Cancel",
      save: "Save",
      cancel: "Cancel",
      renovationStartTime: "Renovation Start Time",
      renovationEndTime: "Renovation End Time",
      renovationCompanyPlaceholder: "Please enter renovation company",
      renovationManagerPlaceholder: "Please enter renovation manager",
      managerPhonePlaceholder: "Please enter manager phone",
      remarkPlaceholder: "Optional remarks",
      acceptanceOpinion: "Acceptance Opinion",
      reviewOpinion: "Review Opinion",
      violationPlaceholder: "Please select if violation",
      violationDescPlaceholder: "Please enter violation description",
      reviewPass: "Review Pass",
      reviewReject: "Review Reject",
      acceptanceSuccess: "Acceptance Success",
      acceptanceFailed: "Acceptance Failure",
      // 表单验证消息
      roomRequired: "Please enter room number",
      contactPersonRequired: "Please enter contact person name",
      phoneRequired: "Please enter phone number",
      startTimeRequired: "Please select renovation start time",
      endTimeRequired: "Please select renovation end time",
      renovationCompanyRequired: "Please enter renovation company",
      renovationManagerRequired: "Please enter renovation manager",
      managerPhoneRequired: "Please enter manager phone number"
    }
  },
  zh: {
    roomRenovationManage: {
      queryCondition: "查询条件",
      hide: "隐藏",
      more: "更多",
      roomNumberPlaceholder: "请输入房屋编号 (如1-1-101)",
      contactPersonPlaceholder: "请输入联系人",
      phonePlaceholder: "请输入联系电话",
      search: "查询",
      reset: "重置",
      statusPlaceholder: "请选择状态",
      postponePlaceholder: "请选择是否延期",
      renovationTimePlaceholder: "请选择装修时间",
      startTimePlaceholder: "请选择开始时间",
      endTimePlaceholder: "请选择结束时间",
      renovationInfo: "装修信息",
      add: "添加",
      room: "房屋",
      contactPerson: "联系人",
      phone: "联系电话",
      renovationTime: "装修时间",
      applyTime: "申请时间",
      renovationCompany: "装修单位",
      renovationManager: "装修负责人",
      managerPhone: "负责人电话",
      status: "状态",
      isPostponed: "是否延期",
      postponeTime: "延期时间",
      isViolation: "是否违规",
      violationDesc: "违规说明",
      remark: "备注",
      operation: "操作",
      fee: "费用",
      review: "审核",
      completeRenovation: "装修完成",
      renovationAcceptance: "装修验收",
      acceptanceDetail: "验收明细",
      modify: "修改",
      delete: "删除",
      trackRecord: "跟踪记录",
      yes: "是",
      no: "否",
      confirmDelete: "确认删除",
      confirmDeleteMsg: "确定删除该装修记录吗？",
      cancelDelete: "点错了",
      confirmComplete: "确认完成",
      confirmCompleteMsg: "确定完成该装修记录吗？",
      cancelComplete: "点错了",
      save: "保存",
      cancel: "取消",
      renovationStartTime: "装修开始时间",
      renovationEndTime: "装修结束时间",
      renovationCompanyPlaceholder: "请输入装修单位",
      renovationManagerPlaceholder: "请输入装修负责人",
      managerPhonePlaceholder: "请输入负责人电话",
      remarkPlaceholder: "选填备注",
      acceptanceOpinion: "验收意见",
      reviewOpinion: "审核意见",
      violationPlaceholder: "请选择是否违规",
      violationDescPlaceholder: "请输入违规说明",
      reviewPass: "审核通过",
      reviewReject: "审核不通过",
      acceptanceSuccess: "验收成功",
      acceptanceFailed: "验收失败",
// 表单验证消息
      roomRequired: "请输入房间号",
      contactPersonRequired: "请输入联系人姓名",
      phoneRequired: "请输入联系电话",
      startTimeRequired: "请选择装修开始时间",
      endTimeRequired: "请选择装修结束时间",
      renovationCompanyRequired: "请输入装修公司",
      renovationManagerRequired: "请输入装修负责人",
      managerPhoneRequired: "请输入负责人电话"
    }
  },
  'zh-TW': {
    roomRenovationManage: {
      queryCondition: "查詢條件",
      hide: "隱藏",
      more: "更多",
      roomNumberPlaceholder: "請輸入房屋編號 (如1-1-101)",
      contactPersonPlaceholder: "請輸入聯繫人",
      phonePlaceholder: "請輸入聯繫電話",
      search: "查詢",
      reset: "重置",
      statusPlaceholder: "請選擇狀態",
      postponePlaceholder: "請選擇是否延期",
      renovationTimePlaceholder: "請選擇裝修時間",
      startTimePlaceholder: "請選擇開始時間",
      endTimePlaceholder: "請選擇結束時間",
      renovationInfo: "裝修信息",
      add: "添加",
      room: "房屋",
      contactPerson: "聯繫人",
      phone: "聯繫電話",
      renovationTime: "裝修時間",
      applyTime: "申請時間",
      renovationCompany: "裝修單位",
      renovationManager: "裝修負責人",
      managerPhone: "負責人電話",
      status: "狀態",
      isPostponed: "是否延期",
      postponeTime: "延期時間",
      isViolation: "是否違規",
      violationDesc: "違規說明",
      remark: "備註",
      operation: "操作",
      fee: "費用",
      review: "審核",
      completeRenovation: "裝修完成",
      renovationAcceptance: "裝修驗收",
      acceptanceDetail: "驗收明細",
      modify: "修改",
      delete: "刪除",
      trackRecord: "跟蹤記錄",
      yes: "是",
      no: "否",
      confirmDelete: "確認刪除",
      confirmDeleteMsg: "確定刪除該裝修記錄嗎？",
      cancelDelete: "點錯了",
      confirmComplete: "確認完成",
      confirmCompleteMsg: "確定完成該裝修記錄嗎？",
      cancelComplete: "點錯了",
      save: "保存",
      cancel: "取消",
      renovationStartTime: "裝修開始時間",
      renovationEndTime: "裝修結束時間",
      renovationCompanyPlaceholder: "請輸入裝修單位",
      renovationManagerPlaceholder: "請輸入裝修負責人",
      managerPhonePlaceholder: "請輸入負責人電話",
      remarkPlaceholder: "選填備註",
      acceptanceOpinion: "驗收意見",
      reviewOpinion: "審核意見",
      violationPlaceholder: "請選擇是否違規",
      violationDescPlaceholder: "請輸入違規說明",
      reviewPass: "審核通過",
      reviewReject: "審核不通過",
      acceptanceSuccess: "驗收成功",
      acceptanceFailed: "驗收失敗",
      roomRequired: "請輸入房間號",
      contactPersonRequired: "請輸入聯繫人姓名",
      phoneRequired: "請輸入聯繫電話",
      startTimeRequired: "請選擇裝修開始時間",
      endTimeRequired: "請選擇裝修結束時間",
      renovationCompanyRequired: "請輸入裝修公司",
      renovationManagerRequired: "請輸入裝修負責人",
      managerPhoneRequired: "請輸入負責人電話"
    }
  }
}